<script>
import axios from 'axios';
import CampaignGant from "@/components/campaignGant";
import CampaignTablePlan from "@/components/campaignTablePlan";

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  components: {CampaignTablePlan,CampaignGant},
  data() {
    return {
      selectedStage: 'timeline',
      options: {
        'timeline': 'Timeline',
        'table': 'Table'
      },

      campaignEvents: [],
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.loader.loading;
    },
    userType() {
      return this.$store.getters['user/userType']
    },
  },
  async created() {
    try {
      this.$store.commit('loader/START_LOADING');

      if (this.userType === 'admin') {
        const response = await axios.get(`/admin/campaign/${this.$route.params.campaignId}/plan`)
        this.campaignEvents = response.data;
      } else if (this.userType === 'client') {
        const response = await axios.get(`/client/campaign/${this.$route.params.id}/plan`)
        this.campaignEvents = response.data;
      }

    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  }
}
</script>

<template>
  <div>

    <div class="text-right">
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group
            id="btn-radios-1"
            class="d-none d-md-block"
            button-variant="outline-primary"
            size="sm"
            v-model="selectedStage"
            :options="options"
            :aria-describedby="ariaDescribedby"
            name="radios-btn-default"
            buttons
        ></b-form-radio-group>
      </b-form-group>
    </div>

    <div  class="row">
      <div class="col-lg-12">

        <h4 v-if="campaignEvents.length === 0 && !isLoading" class="text-center">
          There are no influencers in this campaign.
        </h4>
        <div class="d-none d-md-block" v-else-if="campaignEvents.length !== 0">
          <div :class="{'d-block': selectedStage === 'timeline'}" class="d-none">
            <campaign-gant :campaign="campaign" :campaignEvents="campaignEvents"></campaign-gant>
          </div>
          <div v-if="selectedStage === 'table'">
            <campaign-table-plan :campaignEvents="campaignEvents"></campaign-table-plan>
          </div>
        </div>

        <div class="d-block d-md-none" v-if="campaignEvents.length !== 0">
          <campaign-table-plan :campaignEvents="campaignEvents"></campaign-table-plan>
        </div>

      </div>
    </div>

  </div>
</template>


